import React, { FC } from 'react';
import { t } from '@lingui/macro';
import { Trans } from '@lingui/react';

import { AlertHelp, ChatInbox } from '@rover/icons';
import { Flex } from '@rover/kibble/core';
import useLocationContext from '@rover/react-lib/src/context/useLocationContext';
import useCurrentUserShim from '@rover/shared/js/hooks/useCurrentUserShim';
import { GlobalClasses } from '@rover/shared/js/styles/globalClasses';

import { DesktopMenu, LanguageSelectorMenu, MobileMenuButton } from './menus';
import NavBarItem from './NavBarItem';
import NotificationsCenter from './NotificationsCenter';

export type Props = {
  onToggleMobileMenu: () => void;
  isMobileMenuOpen: boolean;
};

const NavBarRight: FC<Props> = ({ onToggleMobileMenu, isMobileMenuOpen }) => {
  const { isAuthenticated, user } = useCurrentUserShim();
  const { unreadMessageCount = 0 } = user || {};
  const { pathname } = useLocationContext();

  return (
    <Flex alignItems="center" noWrap gap="4x">
      {isAuthenticated ? (
        <>
          <DesktopMenu />

          <NotificationsCenter implementDjangoHacks={false} />

          <GlobalClasses />

          <NavBarItem
            href="/account/inbox/"
            aria-label={`${t`Inbox`} (${unreadMessageCount})`}
            icon={ChatInbox}
            display={['none', 'none', 'block']}
          >
            ({unreadMessageCount})
          </NavBarItem>
        </>
      ) : (
        <>
          <NavBarItem
            href={`/account/continue/?bep=event%3Dnavigation-sign-up&next=${pathname}`}
            rel="nofollow"
            display={['none', 'block']}
          >
            <Trans id="Sign Up" />
          </NavBarItem>
          <NavBarItem
            href={`/account/continue/?bep=event%3Dnavigation-sign-in&action=sign_in&next=${pathname}`}
            rel="nofollow"
            display={['none', 'block']}
          >
            <Trans id="Sign In" />
          </NavBarItem>
        </>
      )}
      <NavBarItem
        href="/help/"
        target="_blank"
        icon={AlertHelp}
        display={['none', 'none', 'block']}
      >
        <Trans id="Help" />
      </NavBarItem>
      <LanguageSelectorMenu />
      <MobileMenuButton
        onClick={onToggleMobileMenu}
        showMobileMenu={isMobileMenuOpen}
        aria-expanded={isMobileMenuOpen}
        display={['block', 'block', 'none']}
      />
    </Flex>
  );
};

export default NavBarRight;
